const plansEn = {
    plans: require('lang/en/plans/Plans').default,
};

export default plansEn;
